import { Icon } from "../../shared";
import { IconTypes } from "../../../../enums";
import { T } from "../../../../constants";
import React from "react";
import { useTranslation } from "../../../../hooks";

interface ModalIconBlockProps {
  iconName: IconTypes;
  text?: string;
  className: string;
}
const ModalIconBlock: React.FC<ModalIconBlockProps> = ({
  iconName,
  text,
  className,
}) => {
  const t = useTranslation();

  return (
    <>
      <div className="ticket-cont">
        <div className="ticket-icon-block">
          <Icon type={iconName} className={className} />
        </div>
      </div>
      {text ? (
        <div className="fot-title-text">
          <p className="popup-title-text-check">{t(text)}</p>
        </div>
      ) : null}
    </>
  );
};

export default ModalIconBlock;
